import { useMemo } from "react";

import { toDraftBody, type DraftBody } from "../mappers";
import type { SegmentFormValues } from "../schemas";

import { useDebounce } from "@/lib/hooks/useDebounce";

export function useDraftBody(
  values: SegmentFormValues,
  clientId: string | undefined,
  debounceMs: number,
): DraftBody {
  const key = JSON.stringify(toDraftBody(values, clientId));
  const debouncedKey = useDebounce(key, debounceMs);
  return useMemo(() => JSON.parse(debouncedKey) as DraftBody, [debouncedKey]);
}
